<template>
  <div class="mdl-grid"  >
    <div class="mdl-cell mdl-cell--4-col"></div>
    <div class="mdl-cell mdl-cell--4-col mdl-card mdl-shadow--2dp">
      <div class="ga-form-title">
        <h2 class="ga-title-text">{{'delay.label.title' | label}}</h2>
      </div>
      <!--<alert message="delay.label.success" goto="/login"></alert>-->
      <alert :message="msg" :goto="next"></alert>
      <div class="mdl-card__actions">
      </div>
    </div>
    <div class="mdl-cell mdl-cell--4-col"></div>
  </div>
</template>

<script>
  var api = require('api')
  module.exports = {
    ready: function () {
      var self = this
      var local = require('common/store/local')
      var token = self.$route.params.token
      if (local.get('client.logged')) {
        self.next = '/app/managed'
      }
      api.Delay.get({
        token: token
      }).then(this.onSuccess).catch(this.onError)
    },
    methods: {
      onSuccess: function () {
        this.$set('msg', 'delay.label.success')
      },
      onError: function (err) {
        this.$set('msg', err.data.message)
      }
    },
    data: function () {
      return {
        msg: '',
        next: '/app/login'
      }
    },
    components: {
      alert: require('c/components/Alert')
    }
  }
</script>



// WEBPACK FOOTER //
// Delay.vue?7685a1ae